export const library_info = {
    description: `<h5>Contacto</h5>
    <p><h6>Biblioteca Central Universidad Panamericana Guatemala</h6>
    <p><span><i class="fas fa-envelope"></i></span> <a href="mailto:biblioteca@upana.edu.gt">biblioteca@upana.edu.gt</a></p>
    <p><span><i class="fas fa-phone-alt"></i></span> <a href="tel:1779">1779</a></p>
    <p><span><i class="fas fa-address-book"></i></span> Diagonal 34, 31-43 zona 16 Guatemala, Guatemala</p>`
};

export const repository_list = [
    {
        displayname: 'Biblioteca Nacional de Guatemala "Luis Cardoza y Aragón"',
        opacURL: "#",
        logo: "/assets/logos/repositories/bng.jpg",
        bgColor: "#fff",
        textColor: "#000",
        height: "100px",
    },
    {
        displayname: "Biblioteca de Ciencias Sociales",
        opacURL: "https://cirma.org.gt",
        logo: "/assets/logos/repositories/cirma.svg",
        bgColor: "#fff",
        textColor: "#000",
        height: "120px",
    },
    {
        displayname: "Biblioteca Paiz Riera",
        opacURL: "https://glifos.unis.edu.gt",
        logo: "/assets/logos/repositories/unis.png",
        bgColor: "#7b001e",
        textColor: "#fff",
        height: "100px",
    },
    {
        displayname: "Biblioteca Ludwig von Mises",
        opacURL: "https://biblioteca.ufm.edu",
        logo: "/assets/logos/repositories/ufm.png",
        bgColor: "#fff",
        textColor: "#000",
        height: "96px",
    },
    {
        displayname: "CRAI Landívar Red de Biblitoecas",
        opacURL: "https://crailandivarlibrary.primo.exlibrisgroup.com/discovery/search?vid=502URL_INST:502URL&tab=LibraryCatalog&lang=es",
        logo: "/assets/logos/repositories/url.png",
        bgColor: "#7b001e",
        textColor: "#fff",
        height: "120px",
    },
    {
        displayname: "Biblioteca UPANA",
        opacURL: "https://glifos.upana.edu.gt",
        logo: "/assets/logos/repositories/upana.png",
        bgColor: "#093479",
        textColor: "#fff",
        height: "98px",
    },
    {
        displayname: "UVG Bibliotecas",
        opacURL: "https://koha.uvg.edu.gt/cgi-bin/koha/opac-main.pl",
        logo: "/assets/logos/repositories/uvg.png",
        bgColor: "#093479",
        textColor: "#fff",
        height: "98px",
    },
    {
        displayname: "Biblioteca UMG",
        opacURL: "https://glifos.umg.edu.gt/opac/",
        logo: "/assets/logos/repositories/umg.png",
        bgColor: "#093479",
        textColor: "#fff",
        height: "120px",
    },
    {
        displayname: "AGH - Biblioteca Jorge Luján Muñoz",
        opacURL: "https://biblioteca.academiageohist.org.gt/opac/",
        logo: "/assets/logos/repositories/AGH.png",
        bgColor: "#093479",
        textColor: "#fff",
        height: "120px",
    }
];


export const repo_metadata = {
    GL_CIRMA: {
        displayname: "Biblioteca de Ciencias Sociales",
        opacURL: "http://cirma.org.gt",
        recordURL: "http://cirma.org.gt/library/index.php?title=",
        phone: "+502 7931-0300",
        phoneLink: "+50279310300",
        email: "biblioteca@cirma.org.gt",
        policy: false,
    },
    GL_UPANA: {
        displayname: "Biblioteca UPANA",
        opacURL: "https://glifos.upana.edu.gt",
        recordURL: "https://glifos.upana.edu.gt/opac/record/",
        phone: "+502 1779 ext. 1208 / 1293",
        phoneLink: "+5021779",
        email: "biblioteca@upana.edu.gt",
        policy: "/opac/assets/files/UPANA_policy.pdf",
    },
    GL_UNIS: {
        displayname: "Biblioteca Paiz Riera",
        opacURL: "https://glifos.unis.edu.gt",
        recordURL: "https://glifos.unis.edu.gt/opac/record/",
        phone: "+502 5612-7002",
        phoneLink: "+50256127002",
        email: "icastillo@unis.edu.gt",
        policy: "/opac/policies/unis",
    },
    GL_UFM: {
        displayname: "Biblioteca Ludwig von Mises",
        opacURL: "https://biblioteca.ufm.edu",
        recordURL: "https://biblioteca.ufm.edu/library/index.php?title=",
        phone: "+502 2338-7821",
        phoneLink: "+50223387821",
        email: "bibliocons@ufm.edu",
        policy: "https://biblioteca.ufm.edu/prestamos/",
    },
};